import { usePageTitle, useScrollToTop } from "../hooks";
import CreditSection from "../components/sections/CreditSection";
import { creditData } from "../data/credit.data";
import presentationBg from "../assets/bg/presentation.webp";

const Credits = () => {
    usePageTitle('Crédits');
    useScrollToTop();
    return (
        <div>
            <div>
                <div
                    className="hidden xl:block absolute inset-0 bg-no-repeat ml-80 bg-cover"
                    style={{
                        backgroundImage: `url(${presentationBg})`,
                        zIndex: -1,
                        opacity: 0.25
                    }}
                ></div>
            </div>
            {creditData.map((credit, index) => (
                <CreditSection
                    key={index}
                    details={credit.details}
                />
            ))}
        </div>
    );
}

export default Credits;